module.exports = __webpack_public_path__ + "img/hero_shelves.22c64faa.png";